<template>
	<div>
		<div class="container">
			<h1>{{ $t('reviewsPage.title') }}</h1>
			<div class="reviews-grid">
				<ReviewCard
					v-for="(review, i) in reviews"
					:key="i"
					:review="review"
					class="reviews-grid__item"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import ReviewCard from '@/components/ReviewCard'

export default {
	components: {
		ReviewCard,
	},

	computed: {
		reviews() {
			return this.$store.getters['reviews/reviewsByLocale']
		},
	},
}
</script>

<style lang="scss" scoped>
@import '@/sass/_variables';

.reviews-grid {
	&__item:not(:last-child) {
		margin-bottom: 24px;
	}
}
@media (max-width: $md) {
	.reviews-grid {
		&__item:not(:last-child) {
			margin-bottom: 16px;
		}
	}
}
</style>
